<div class="banner-area banner-img-oneCopy"  >
 
    <div class="container container-layout">
       
  
        <div class="row row-margin home-div">
            
            <div class="col-lg-6 col-md-6  col-sm-12 col-xs-12  col-padding">
                <app-live></app-live>
                
            </div>
  
            <div class="col-lg-6 col-md-6  col-sm-12 col-xs-12  col-padding">
                <ngb-carousel style="     background: #f0f0f0;   width: 100%;  height: 100%;">
                        
                    <ng-template ngbSlide *ngFor="let item of sliderNews">
                     
                    <a [routerLink]="['/news',
                    formatRoute(item?.NewsTitle.trim()), 
                    item?.NewsId]">
                      <div class="picsum-img-wrapper">

                        <img  class="img-fluid" [src]="prefixUrl+item?.ImagePath" 
                        loading="lazy"
                        alt="Random first slide">
                      </div>
                    </a>
                
                     
                      <div class="carousel-caption">
                     
                    <a [routerLink]="['/news',
                    formatRoute(item?.NewsTitle.trim()), 
                    item?.NewsId]">
                        <p>{{ item.NewsTitle}}</p>
                    </a>
                      </div>
                 
                    </ng-template>
                  </ngb-carousel>

            </div>
        </div>
          
        <div class="row row-margin home-div " style="margin-top: -40px;  ">
            <div class="col-md-6 col-sm-12 col-padding">
                <app-breaking-news></app-breaking-news>
            </div>
            <div class="col-md-6 col-sm-12 col-padding">
                      <div class="video-container-291" >
                    <a
                    routerLink="/video/{{
                        firstVideoLink?.VideoId
                    }}"
                    
                    >

                    <img
                     
                    class="img-fluid story-image"
                    [src]="prefixUrl+firstVideoLink?.ImagePath"
                     alt="Blog"
                    loading="lazy"
                    
                />
        
       
                </a>
                   
                  
                </div>  
               
            </div>
        </div>


         <div class="row row-margin"  >
           
            <ng-container *ngFor="let newsItem of latestNews">
                <div
                    class="col-md-4 col-sm-6 col-xs-12"
                    style="margin-bottom: 7px"
                >
                    <div class="card card-home">
                        <a [routerLink]="['/news', formatRoute(newsItem?.CategoryName.trim()), formatRoute(newsItem?.NewsTitle.trim()), newsItem?.NewsId]">

                         
                            <div class="card-body" style="background: none">
                                <h5 class="category-header">
                                      {{ newsItem.CategoryName }}
                                </h5>
                                <div class="row">
                                    <div
                                        class="col-lg-5 col-md-5 col-xs-12 card-img-new"
                                    >
                                        <img
                                            style="  max-height: 8rem;width: 100%;"
                                            class="img-fluid"
                                            [src]="prefixUrl +newsItem?.ImagePath"
                                            alt="Blog"
                                            loading="lazy"
                                        />
                                    </div>
                                    <div
                                        class="col-lg-7 col-md-7 col-xs-12 card-text"
                                    >
                                        <h6
                                            class="news-title"
                                            style="font-weight: bold"
                                        >
                                            {{ newsItem?.NewsTitle }}
                                        </h6>

                                        <p class="news-content">
                                            {{ newsItem?.NewsIntroduction }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
               
            </ng-container>
        </div>

        <br />
    </div>

    <div class="container">
        <div class="row row-margin">
            <div class=" col-lg-12" style="margin: 6px" *ngIf="advsTwo ==null">
                <a href="#"><img class="td-retina img-responsive" src="assets/img/news/Video21290-180.gif" alt=""></a>
            </div>

            <div class=" col-lg-12" style="margin: 6px" *ngIf="advsTwo !=null">
                <a  href="{{advsTwo.Link}}" target="_blank"><img class="td-retina img-responsive"   loading="lazy"   [src]="adsPrefixUrl+ advsTwo?.ImagePath" alt=""></a>
            </div>
           
        </div>
    </div>
</div>
<br/>
<section >
    <div class="container">
        <div class="b-t1 pa6">
        <a routerLink="/videos">
            <h4 class="category-header">فيدوهات</h4>
            
        </a>
    </div>
       

        <div class="row  pb-70" >
            <ng-container *ngFor="let videoItem of videosData">

                <div
                class="col-md-3 col-sm-6 col-xs-12"
                style="margin-bottom: 7px"
            >
                <div class="card card-home">
                    <a
                    routerLink="/video/{{
                        videoItem.VideoId
                    }}"
                    >
                        <div class="card-body" style="background: none">
                           
                            <div class="row">
                                <div
                                class="col-lg-6 col-md-6 col-xs-12 card-text"
                            >
                                <h6
                                    class="news-title"
                                    style="font-weight: bold;     -webkit-line-clamp: 4;    "
                                >
                                    {{ videoItem?.VideoTitle }}
                                </h6>

                                 
                            </div>
                                <div
                                    class="col-lg-6 col-md-6 col-xs-12 card-img-new"
                                >
                              
                                <img
                                    style="  max-height: 10rem;"
                                    class="img-fluid"
                                    [src]="prefixUrl+videoItem?.ImagePath"
                                    loading="lazy"
                                    alt="Blog"
                                />
                        
                                </div>
                              
                            </div>
                        </div>
                    </a>
                </div>
            </div>



              
            </ng-container>
        </div>


        <div class="row">
            <div class=" pa6">
                <a routerLink="/">
                    <h4 class="category-header">موضوعاتنا
                        <i class="fa fa-sort-desc" aria-hidden="true"></i>
                    </h4>
                </a>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-12">
           <app-tobics></app-tobics>

            <div class="header-banner" *ngIf="advsThree == null">
                <a href="#"
                    ><img
                        style="width: 100%"
                        class="td-retina img-responsive"
                        src="assets/img/news/Video1728-90.gif"
                        alt=""
                        loading="lazy"
                /></a>
            </div>
            <div class="header-banner" *ngIf="advsThree != null">
                <a href="{{advsThree.Link}}" target="_blank"
                    ><img
                        style="width: 100%"
                        class="td-retina img-responsive"
                        [src]="adsPrefixUrl+advsThree?.ImagePath"
                        alt=""
                        loading="lazy"
                /></a>
            </div>
        </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
                <app-weather-conditions></app-weather-conditions>
                <app-exchange-rates></app-exchange-rates>
            </div>
        </div>
    </div>
</section>
 
<ng-container *ngFor="let item of CategoryNewsData">
    <section class="practice-area pt-100 pb-70" *ngIf="item.news.firstThree.length > 0 && item.news.remaining.length > 0">
        <div class="container">
            <div class="section-header">
                <a
                    [routerLink]="['/category',formatRoute(item?.CategoryTitle.trim()) 
                       , item?.CategoryId ]"
                >

                    <h2 class="section-title">
                        {{ item.CategoryTitle }}
                    </h2>
                </a>
                <div class="section-more-link">
                    <a
                    [routerLink]="['/category',formatRoute(item?.CategoryTitle.trim()) 
                       , item?.CategoryId ]"
                >
                        <span class="more-text">المزيد</span>
                        <svg
                            class="more-icon"
                            width="8"
                            height="13"
                            viewBox="0 0 8 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M7.90747 11.3642L3.35632 6.63623L7.90747 1.90823L6.68305 0.63623L0.907471 6.63623L6.68305 12.6362L7.90747 11.3642Z"
                                fill="white"
                            ></path>
                        </svg>
                    </a>
                </div>
            </div>
            <!--<div class="section-title">
            <span>HOW CAN WE HELP YOU</span>
            <h2>Our Legal Practices Areas</h2>
        </div>-->
        <ng-container
        *ngIf="
            item.news.firstThree &&
            item.news.firstThree.length > 0
        "
         >
            <div class="row">
             
                    <div class="col-lg-8  col-md-12 col-sm-12 border-b">
                       
                        <a [routerLink]="['/news',formatRoute(item?.CategoryTitle.trim()),
                         formatRoute(item?.news.firstThree[0].NewsTitle.trim()), 
                           item?.news.firstThree[0].NewsId]">
                            <div>
                                <div
                                    class="practice-item"
                                    
                                >
                                    <div>
                                        <img
                                        class="img-fluid img-size100 max-height-33"
                                            [src]="prefixUrl + item.news.firstThree[0]?.ImagePath"
                                            loading="lazy"
                                            alt="Shape"
                                           
                                        />
                                    </div>
                                    <h3>
                                        {{ item.news.firstThree[0].NewsTitle }}
                                    </h3>
                                    <p>
                                        {{
                                            item.news.firstThree[0]
                                                .NewsIntroduction
                                        }}
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div
                        class=" col-lg-4  col-md-6 col-sm-12   border-b"
                        *ngIf="item.news.firstThree.length > 1"
                    >
                        
                        <a [routerLink]="['/news',formatRoute(item?.CategoryTitle.trim()),
                        formatRoute(item?.news.firstThree[1].NewsTitle.trim()), 
                          item?.news.firstThree[1].NewsId]">
                        
                            <div class="practice-item img-fluid"  >
                                <img
                                
                                class="img-fluid max-height-17"
                                    [src]="prefixUrl + item.news.firstThree[1]?.ImagePath"
                                    loading="lazy"
                                    alt="Shape"
                                  
                                />

                                <h5 class="news-title">
                                    {{ item.news.firstThree[1]?.NewsTitle }}
                                </h5>
                                <p>
                                    {{
                                        item.news.firstThree[1]
                                            ?.NewsIntroduction
                                    }}
                                </p>
                            </div>
                        </a>
                         
                        <a [routerLink]="['/news',formatRoute(item?.CategoryTitle.trim()),
                        formatRoute(item?.news.firstThree[2].NewsTitle.trim()), 
                          item?.news.firstThree[2].NewsId]">
                            <div
                                class="practice-item"
                                
                                *ngIf="item.news.firstThree.length >= 2"
                            >
                                <img
                                loading="lazy"
                             class="img-fluid max-height-17"
                                    [src]="prefixUrl + item.news.firstThree[2]?.ImagePath"

                                    alt="Shape"
                                   
                                />

                                <h5 class="news-title">
                                    {{ item.news.firstThree[2]?.NewsTitle }}
                                </h5>
                                <p>
                                    {{
                                        item.news.firstThree[2]
                                            ?.NewsIntroduction
                                    }}
                                </p>
                            </div>
                        </a>
                    </div>
                
            </div>
        </ng-container>
                <div class="row">
                    <ng-container
                        *ngFor="let subItem of item.news.remaining"
                    >
                        <div class=" col-lg-4 col-md-6 col-sm-12">
                             
                            <a [routerLink]="['/news',formatRoute(item?.CategoryTitle.trim()),
                            formatRoute(subItem?.NewsTitle.trim()), 
                            subItem?.NewsId]">
                                <div class="practice-item">
                                    <div>
                                        <img
                                            class=" img-fluid news-cover-img"
                                            [src]="prefixUrl + subItem?.ImagePath"
                                            loading="lazy"
                                            alt="Shape"
                                             
                                        />
                                    </div>
                                    <h5 class="news-title">
                                        {{ subItem.NewsTitle }}
                                    </h5>
                                    <p>{{ subItem.NewsIntroduction }}</p>
                                </div>
                            </a>
                        </div>
                    </ng-container>
                </div>
         
        </div>
    </section>
</ng-container>

<br />
<br />

